import { FC } from 'react';

import classNames from 'classnames';

import { ITariff } from '../../store/tariff.slice';
import { Heading } from '../../shared/ui';

export interface ITariffCardHeaderProps {
  tariff: ITariff;
  modal?: boolean;
  showEmptyDescription1?: boolean;
}

export const TariffCardHeader: FC<ITariffCardHeaderProps> = ({ tariff, modal, showEmptyDescription1 = true }) => {
  const hasDescription1 = Boolean(tariff.description_1 && tariff.description_1.trim() !== '');

  return (
    <div className="text-center leading-tight">
      <Heading size="lg" className="mb-2">
        {tariff.name}
      </Heading>
      {(showEmptyDescription1 || hasDescription1) && (
        <p
          className={classNames('text-black text-body-l mb-1 min-h-[24px]', {
            'text-body-l': !modal,
            'text-body-xl': modal,
          })}
        >
          {tariff.description_1 || ' '}
        </p>
      )}

      <p className="text-display-m text-primary">
        {tariff.price.toLocaleString('ru-RU')} {tariff.currency_symbol}
      </p>
    </div>
  );
};
